import './App.css';
import unmuteIosAudio from 'unmute-ios-audio';

import React, { useState, useEffect } from 'react';
import Home from '../pages/Home';
import Player from '../pages/Player';

import List from '../components/List';



import { useHistory, Route, Switch,Redirect} from 'react-router-dom';

import bgGradient from '../bgGradient.png'

function App() {
  console.log("unmuting");
  unmuteIosAudio();

 const [data,setData]=useState([]);
 const [firstTime, setFirstTime]=useState(true);



 const  content = useHistory();
 const getData=()=>{

  fetch('REAL_DATA.json',{
    headers : {'Content-Type': 'application/json','Accept': 'application/json' }})
  .then(function(response){
      console.log(response)
      return response.json();
    })
    .then(function(myJson) {
     // console.log(myJson);
      setData(myJson)
    });

}


useEffect(()=>{
  getData()
},[])

  return (


    <div className="App" style={{

    }}>
      <div className="content">

<Switch>
  <Route path="/" exact render={(props) => data && data.length>0 &&  <Home json={data} query={content} firstTime={firstTime} updateFirstTime={setFirstTime}></Home>}  />

  <Route path="/player" render={(props) => data && data.length>0 &&  <Player json={data} query={content} firstTime={firstTime} updateFirstTime={setFirstTime}></Player>} />
  </Switch>
</div>
    </div>
  );
}

//{data && data.length>0 && <List key={0} content={content} dataListe={data}/>}

//

export default App;
